import { getWallSize } from './get-wall-size';
import { HelperLinesService } from '../../helper-lines.service';

declare const THREE: any;

const matrix = new THREE.Matrix4();
const wallBox = new THREE.Box3();

/**
 *@description
 * Check if object within
 * wall area
 * TODO: abstract for other mountable
 * objects
 * @param {any} wall
 * @param {any} entity
 * @param {any} position
 * @param {any} rotation
 * @function
 */
export const mountableObjectIsWithinWallArea = (wall, { width, length, height }, position, rotation): boolean => {
  let withinWallArea = false;
  const wallDirection = wall.getWorldDirection(new THREE.Vector3());
  const wallSize = getWallSize(wall);
  wall.getWorldDirection(wallDirection);

  const objPositionInsideWall = position
    .clone()
    .sub(wallDirection.multiplyScalar(wallSize.z / 2 + width / 2));

  const points = [
    objPositionInsideWall.clone().add(
      wallDirection
        .clone()
        .applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2)
        .setLength(length / 2)
    ),
    objPositionInsideWall.clone().add(
      wallDirection
        .clone()
        .applyAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2)
        .setLength(length / 2)
    ),
    objPositionInsideWall.clone().add(new THREE.Vector3(0, height / 2, 0)),
    objPositionInsideWall.clone().add(new THREE.Vector3(0, -height / 2, 0))
  ];

  if (!wall.geometry.boundingBox) wall.geometry.computeBoundingBox();

  wallBox.copy(wall.geometry.boundingBox);
  wallBox.applyMatrix4(wall.matrixWorld);

  matrix.identity();
  matrix.makeRotationFromEuler(rotation);
  matrix.setPosition(position);
  // position: { x: number; y: number; z: number },
  // colorNumber = 0,
  // name?
  // points.forEach((p, i) => {
  //   console.log('`${i}-constraint-line`', `${i}-constraint-line`);
  //   HelperLinesService.buildOneTestLineAndUpdate(p, 0, `${i}-constraint-line`);
  // });

  if (points.every(p => wallBox.containsPoint(p))) {
    withinWallArea = true;
  }

  return withinWallArea;
};



// WEBPACK FOOTER //
// ./src/app/services/wall/utils/mountable-object-is-within-wall-area.ts